import { useMemo } from 'react';
import { useQuery } from 'App/hooks';
import { NE_PRINT_LABEL_SOURCE } from 'domains/NuvemEnvioCommons/constants';

type UseLabelPrintingQueryProps = {
  fulfillmentOrderIdsKey: string;
};

type UseLabelPrintingQueryResult = {
  orderId: string;
  fulfillmentOrderIds: string[];
  source: NE_PRINT_LABEL_SOURCE;
};

const DEFAULT_PROPS: UseLabelPrintingQueryProps = {
  fulfillmentOrderIdsKey: 'fulfillmentOrderIds',
};

export const useLabelPrintingQuery = (
  props: UseLabelPrintingQueryProps = DEFAULT_PROPS,
): UseLabelPrintingQueryResult => {
  const query = useQuery();
  const orderId = query.get('orderId') ?? '';
  const fulfillmentOrderIds = useMemo(
    () => query.get(props.fulfillmentOrderIdsKey)?.split(',') ?? [],
    [query, props.fulfillmentOrderIdsKey],
  );
  const rawSource = query.get('source');
  const source = isPrintLabelSource(rawSource)
    ? rawSource
    : NE_PRINT_LABEL_SOURCE.ORDERS_LIST;

  return { orderId, fulfillmentOrderIds, source };
};

const isPrintLabelSource = (
  value: string | null,
): value is NE_PRINT_LABEL_SOURCE =>
  value !== null &&
  Object.values(NE_PRINT_LABEL_SOURCE).includes(value as NE_PRINT_LABEL_SOURCE);
